import { createFetchAction } from '../utils';
import * as phraseCpsrChapterTypes from './phraseCpsrChapterTypes';

export const fetchPhraseCpsrChapters = createFetchAction(
  phraseCpsrChapterTypes.FETCH_PHRASE_CPSR_CHAPTERS,
  'PhraseCpsrChapterId',
);
